module.exports = __webpack_public_path__ + "img/5NP.98e83b26.png";